"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
const FormGroup_1 = __importDefault(require("@mui/material/FormGroup"));
const Switch_1 = __importDefault(require("@mui/material/Switch"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const react_1 = __importDefault(require("react"));
const styles_1 = require("@mui/material/styles");
const IOSSwitch = (0, styles_1.styled)((props) => (react_1.default.createElement(Switch_1.default, { focusVisibleClassName: ".Mui-focusVisible", disableRipple: true, ...props })))(({ theme }) => ({
    width: 52,
    height: 33,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 4,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(20px)',
            '& + .MuiSwitch-track': {
                opacity: 1,
                border: 0,
                height: 33,
            },
            '& .MuiSwitch-thumb': {
                backgroundColor: '#FFFFFF',
                width: 24,
                height: 24,
                color: theme.palette.grey[600],
                margin: 0.5,
            },
        },
    },
    '& .MuiSwitch-thumb': {
        width: 16,
        height: 16,
        color: theme.palette.grey[600],
        margin: 4,
    },
    '& .MuiSwitch-track': {
        height: 28,
        borderRadius: 32 / 2,
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
        border: '2px solid',
        backgroundColor: theme.palette.common.white,
        borderColor: theme.palette.grey[200],
    },
}));
const SwitchButton = ({ onChange, selected, label, value, ...rest }) => {
    const handleChange = (e) => {
        onChange(e.target.checked);
    };
    return (react_1.default.createElement(FormGroup_1.default, { onChange: handleChange, "data-testid": "switch-button" },
        react_1.default.createElement(FormControlLabel_1.default
        //@ts-ignore
        , { 
            //@ts-ignore
            key: value, checked: selected, control: react_1.default.createElement(IOSSwitch, { value: value, ...rest }), label: react_1.default.createElement(Typography_1.default, { variant: "body2", px: 1 }, label) })));
};
exports.default = SwitchButton;
